// import { useEffect } from "react";
import { useAuth } from "../../utils/auth";
import { useActiviteiten } from "../../utils/activiteiten";
import { formatDateShort } from "../../helperfunctions/helperfunctions";



const MyActiviteiten = () => {

    const auth = useAuth();
    const act = useActiviteiten();


    return (
        <>
            <h3>Mijn aankomende activiteiten: </h3>
            <div className="myActiviteiten">
                { act.myActiviteiten && act.myActiviteiten.map((item, i) => {
                    const shownDatum = formatDateShort(item.datum);
                    return (
                        <div key={item._id}>
                            <div className="listItem"> 
                                <span className="homeDatum">{shownDatum}</span> 
                                <span className="itemNaam"> {item.naam}</span>
                            </div>
                            {item.taken.map((taak, i) => {
                                if (taak.vrijwilliger) {
                                    if (taak.vrijwilliger._id === auth.user._id) {
                                        return (
                                            <div key={i}>
                                                <p className="taakNaam">{`${taak.taaknaam}`}</p>
                                                <p>Dagdeel: {taak.dagdeel}</p>
                                                <p>Aanvangstijd: {taak.aanvangstijd} </p>
                                                <p>Extra info: {taak.vrijwilligersInfo}</p>

                                            </div>    
                                        )
                                    }

                                }
                            })}
                        </div>
                    )

                })
                }

                { !act.myActiviteiten[0] && <p>Je hebt (nog) geen aankomende vrijwilligers taken.</p>}

            </div>

        </>
    );
}

export default MyActiviteiten;